var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.9996 7.99899C21.9994 7.82052 21.9514 7.64535 21.8607 7.49166C21.77 7.33798 21.6398 7.21137 21.4836 7.12499L12.4616 2.12499C12.3133 2.04332 12.1468 2.00049 11.9776 2.00049C11.8083 2.00049 11.6418 2.04332 11.4936 2.12499L2.51558 7.08499C2.35961 7.17136 2.22957 7.29785 2.13892 7.45136C2.04827 7.60487 2.00031 7.77983 2 7.95811C1.9997 8.13639 2.04706 8.31151 2.13718 8.46534C2.2273 8.61916 2.35691 8.7461 2.51258 8.83299L11.5346 13.873C11.6831 13.9564 11.8506 14.0004 12.0209 14.0005C12.1913 14.0007 12.3589 13.9571 12.5076 13.874L21.4856 8.87399C21.6415 8.78727 21.7714 8.6604 21.8618 8.50654C21.9522 8.35268 21.9998 8.17744 21.9996 7.99899ZM12.0226 11.854L5.05958 7.96499L11.9766 4.14299L18.9406 8.00199L12.0226 11.854Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5147 11.126L11.9997 15.856L3.48467 11.126L2.51367 12.874L11.5137 17.874C11.6622 17.9565 11.8293 17.9998 11.9992 17.9998C12.1691 17.9998 12.3361 17.9565 12.4847 17.874L21.4847 12.874L20.5147 11.126Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5147 15.126L11.9997 19.856L3.48467 15.126L2.51367 16.874L11.5137 21.874C11.6622 21.9565 11.8293 21.9998 11.9992 21.9998C12.1691 21.9998 12.3361 21.9565 12.4847 21.874L21.4847 16.874L20.5147 15.126Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStack);
export default __webpack_public_path__ + "static/media/stack.75666aff42b818eba043cbb6c2187cde.svg";
export { ForwardRef as ReactComponent };